import { Button, Layout, Modal, Spin } from 'antd'
import { t } from 'i18next'
import React, { useEffect, useState } from 'react'
import { PlusOutlined } from '@ant-design/icons'
import { useForm } from 'antd/es/form/Form'
import { get, post } from '../../Common/api'
import { Color } from '../../Common/Color'
import TeleconsultingCompanyForm from './TeleconsultingCompanyForm'
import TeleconsultingCompaniesList from './TeleconsultingCompaniesList'

export default function TeleconsultingCompaniesPage () {
  const [teleconsultingCompanies, setTeleconsultingCompanies] = useState([])
  const [loading, setLoading] = useState(false)
  const [modalVisible, setModalVisible] = useState(false)
  const [form] = useForm()

  useEffect(() => {
    getTeleconsultingCompanies()
  }, [])

  const getTeleconsultingCompanies = async () => {
    setLoading(true)
    await get('admin/teleconsulting_companies', {}, (res) => {
      setLoading(false)
      setTeleconsultingCompanies(res)
    }, () => {
      setLoading(false)
    })
  }

  const postTeleconsultingCompany = async (params) => {
    setLoading(true)
    await post('admin/teleconsulting_companies', params, () => {
      setModalVisible(false)
      setLoading(false)
      getTeleconsultingCompanies()
    }, (errors) => {
      setLoading(false)
      form.setFields(
        Object.keys(errors).map((key) => ({
          name: key,
          errors: errors[key]
        }))
      )
    })
  }

  const openAddModal = () => {
    form.resetFields()
    setModalVisible(true)
  }

  const onAdd = async (values) => {
    await postTeleconsultingCompany(values)
  }

  return (
    <Layout>
      <Layout style={{ padding: '1em 0', color: Color.dark_blue, fontSize: '24px' }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div style={{ marginRight: '20px' }}><b>{teleconsultingCompanies.length}</b> {t('Admin.TeleconsultingCompaniesPage.title')}</div>
          <Button onClick={openAddModal} type="primary" style={{ marginLeft: 'auto' }} shape="circle" icon={<PlusOutlined />} />
        </div>
      </Layout>
      <Spin spinning={loading}>
        <TeleconsultingCompaniesList teleconsultingCompanies={teleconsultingCompanies}/>
        {modalVisible && <Modal
          open={modalVisible}
          width="1000px"
          title={t('Admin.TeleconsultingCompaniesPage.addTitle')}
          okText={t('actions.validate')}
          onOk={form.submit}
          onCancel={() => setModalVisible(false)}
          confirmLoading={loading}
        >
          <Spin spinning={loading}>
            <TeleconsultingCompanyForm form={form} onFinish={onAdd}/>
          </Spin>
        </Modal>}
      </Spin>
    </Layout>
  )
}
